import { component } from 'picoapp';
import Drawer from 'utils/drawer';

export default component((node) => {
  const drawer = Drawer(node);
  const { id: identifier, breakpoint } = node.dataset;

  const trigger = document.querySelector<HTMLElement>(`[data-trigger="faq-answer-${identifier}"]`);
  const closeAnswerDrawer = node.querySelector('[data-close-faq-answer]');

  if (!drawer || !trigger) return;

  trigger.addEventListener('click', (e) => {
    if (!window.matchMedia(breakpoint).matches) return;

    e.preventDefault();
    drawer.open();
  });

  closeAnswerDrawer.addEventListener('click', () => {
    if (!window.matchMedia(breakpoint).matches) return;

    drawer.close();
  });
});
